module.exports = __webpack_public_path__ + "static/media/merchantProfile.b0018e62.pdf";